// TemplatesModal.jsx
import { useState } from 'react';
import { Modal, Typography, Select } from 'antd';
import { notify_error } from "./Notify";

const { Title } = Typography;
const { Option } = Select;

const TemplatesModal = ({ visible, onClose, templates, onTemplateClick }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const handleSubmit = () => {
    if (selectedTemplate) {
      onTemplateClick(selectedTemplate);
    } else {
      notify_error("Please select a template.");
    }
  };

  return (
    <Modal
      visible={visible}
      open={visible}
      onCancel={onClose}
      style={{ zIndex: 1050 }}
      footer={null}
      centered
    >
      {console.log("Rendering Modal", visible)}
      <div style={{ padding: 24 }}>
        <Title level={4}>All templates</Title>

        <Select
        virtual={false} 
          placeholder="Select a template"
          style={{ width: '100%', marginBottom: 16 }}
          onChange={(value) => {
            const template = templates.find(t => t.template_name === value);
            setSelectedTemplate(template);
          }}
        >
          {templates.map((template) => (
            <Option key={template.template_name} value={template.template_name}>
              {template.template_name}
            </Option>
          ))}
        </Select>

        <button
        className="spButton1 py-1 px-3 me-2"
          type="primary"
          style={{ width: '100%' }}
          onClick={handleSubmit}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default TemplatesModal;
